import * as React from "react";
import { cn } from "@/lib/utils";

export interface SheetProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onClose: () => void;
}

export const Sheet: React.FC<SheetProps> = ({ open, onClose, className, children, ...props }) => {
  if (!open) return null;
  return (
    <div className={cn("fixed inset-0 z-50 flex", className)} {...props}>
      <div className="fixed inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-gradient-to-br from-teal-400 to-teal-700 text-white w-64 min-h-screen rounded-tl-2xl shadow-lg p-4">
        {children}
      </div>
    </div>
  );
};
